import React, { createContext, useEffect, useState, useContext } from "react";
import { auth } from "../firebase/firebase";
import { ConfigContext } from "../context/ConfigContext.js";
import { setApiToken } from "../../../utils/apiToken";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [mensaje, setMensaje] = useState(null);
  const [estadoUsuario, setEstadoUsuario] = useState("cargando");
  const [userType, setUserType] = useState(null);
  // se conserva aparte de `usuario` porque este se limpia a null en cuanto
  // estadoUsuario pasa a "no-autorizado", pero la pantalla de "ya tienes una
  // materia registrada" todavía necesita saber a quién pertenece el intento.
  const [emailIntento, setEmailIntento] = useState(null);
  const config = useContext(ConfigContext);

  useEffect(() => {
    if (!config) return;

    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setEmailIntento(currentUser.email);
        try {
          const url = `https://api.micrositec.com/api/login`;
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: currentUser.email }),
          });
          if (response.status === 200) {
            const json = await response.json();

            if (json.ok === true) {
              setApiToken(json.token);
              setUsuario(currentUser);
              setEstadoUsuario("autorizado");
              setUserType(json.data?.[0]?.UserType || null);
            } else {
              // El caso "ya tienes una materia registrada" también trae token
              // (el usuario sigue siendo un ALLOW válido y lo necesita para
              // poder llamar /desinscribir desde el modal de "Cambiar actividad").
              // En cualquier otro fault (no encontrado, sin permiso, etc.) el
              // backend no manda token y esto lo deja en null.
              setApiToken(json.token || null);
              setMensaje(json.message);
              setUsuario(null);
              setEstadoUsuario("no-autorizado");
              setUserType(null);
            }
          } else {
            setApiToken(null);
            setUsuario(null);
            setEstadoUsuario("no-autorizado");
            setUserType(null);
          }
        } catch (error) {
          console.error("Error en validación:", error);
          setApiToken(null);
          setEstadoUsuario("error");
        }
      } else {
        setUsuario(null);
        setEstadoUsuario("no-autenticado");
        setUserType(null);
        // OJO: NO se limpian emailIntento ni apiToken aquí. El flujo de "ya
        // tienes una materia registrada" hace signOut() automático justo
        // después de mostrar el modal, lo que dispara este mismo `else` de
        // inmediato — si se limpiaran aquí, se perdía el email y el token
        // antes de que el usuario alcanzara a escribir la clave para
        // desinscribirse. Ambos se sobreescriben solos (con los valores
        // correctos, o con null) la próxima vez que alguien inicie sesión.
      }
    });

    return () => unsubscribe();
  }, [config]);

  return (
    <AuthContext.Provider value={{ usuario, estadoUsuario, mensaje, userType, emailIntento }}>
      {children}
    </AuthContext.Provider>
  );
};
